<ui-card-table
  [showDrawer]="showDrawer"
  [hasBackdrop]="true"
  (openedDrawerChange)="openedDrawerChange($event)"
>
  <h4 card-title>Conductores</h4>
  <div card-search-action>
    <commonui-search #searchFilter (searchText)="onSearch($event)"></commonui-search>
  </div>

  <div class="d-flex justify-content-between" card-actions>
    <t-llevo-select-filter
      #vehicleTypeFilter
      label="Tipo de vehículo"
      [data]="vehicleTypes() ?? []"
      (valueChange)="filter()"
      [disabled]="(dataSource.loading$ | async) ?? false"
      class="mx-1"
      cancelSelectionText="Desactivar filtros"
    ></t-llevo-select-filter>
    <button
      class="button-outline-primary mb-1 controls-button"
      mat-flat-button
      color="accent"
      (click)="openAddDriverDialog()"
      class="mx-2"
    >
      Adicionar
    </button>
  </div>

  <div card-sm-actions>
    <t-llevo-select-filter
      #vehicleTypeFilter
      label="Tipo de vehículo"
      [data]="vehicleTypes() ?? []"
      (valueChange)="filter()"
      [disabled]="(dataSource.loading$ | async) ?? false"
      class="mx-1"
      cancelSelectionText="Desactivar filtros"
    ></t-llevo-select-filter>
    <button mat-icon-button color="accent" (click)="openAddDriverDialog()">
      <mat-icon class="d-flex" svgIcon="plus"></mat-icon>
    </button>
  </div>

  <div
    card-drawer-content
    class="row align-items-start justify-content-start w-100 gx-0"
    commonui-loader
    [appLoader]="(dataSource.loading$ | async) ?? false"
  >
    <div class="col-12">
      <mat-table
        [dataSource]="dataSource"
        matSort
        matSortActive="name"
        matSortDisableClear
        matSortDirection="asc"
      >
        <ng-container matColumnDef="name">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            disableClear
            class="d-none d-md-flex"
          >
            Nombre
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="d-none d-md-flex">
            {{ item.user ? item.user.firstname : (item | json) }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lastname">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
            Apellidos
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.user.lastname }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dni">
          <mat-header-cell *matHeaderCellDef class="d-none d-sm-flex"
            >CI</mat-header-cell
          >
          <mat-cell *matCellDef="let item" class="d-none d-sm-flex">
            {{ item.ci }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="vehicle">
          <mat-header-cell *matHeaderCellDef>Vehículo</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.vehicle.vehicleType.name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="registrationNumber">
          <mat-header-cell *matHeaderCellDef>Matrícula</mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.vehicle.plate }}
          </mat-cell>
        </ng-container>

        <!-- Actions Column -->
        <!-- PC ACTIONS LIST -->
        <ng-container matColumnDef="actions">
          <mat-header-cell
            class="action-col-centered justify-content-center"
            *matHeaderCellDef
          >
            Acciones
          </mat-header-cell>
          <mat-cell class="action-col-centered" *matCellDef="let item">
            <div class="d-none d-lg-flex">
              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Detalles"
                  (click)="detail(item)"
                >
                  <mat-icon svgIcon="eye"></mat-icon>
                </button>
              </ng-container>

              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Editar"
                  (click)="openEditDriverDialog(item)"
                >
                  <mat-icon svgIcon="pencil" class="me-1"></mat-icon>
                </button>
              </ng-container>

              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Eliminar"
                  (click)="openDeleteDialog(item)"
                >
                  <mat-icon
                    svgIcon="trash-can"
                    class="action_element"
                  ></mat-icon>
                </button>
              </ng-container>

              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Cambiar contraseña"
                  (click)="openChangePasswordDialog(item)"
                >
                  <mat-icon
                    svgIcon="password"
                    class="action_element"
                  ></mat-icon>
                </button>
              </ng-container>
            </div>

            <!-- MOBILE ACTIONS MENU-->
            <div class="d-block d-lg-none">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Acciones"
              >
                <mat-icon
                  svgIcon="expand_vert"
                  class="action_element"
                ></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-container>
                  <button mat-menu-item (click)="detail(item)">
                    <mat-icon svgIcon="eye"></mat-icon>
                    <span>Detalles</span>
                  </button>
                </ng-container>

                <ng-container>
                  <button mat-menu-item (click)="openEditDriverDialog(item)">
                    <mat-icon svgIcon="pencil"></mat-icon>
                    <span>Editar</span>
                  </button>
                </ng-container>

                <ng-container>
                  <button mat-menu-item (click)="openDeleteDialog(item)">
                    <mat-icon svgIcon="trash-can"></mat-icon>
                    <span>Eliminar</span>
                  </button>
                </ng-container>

                <ng-container>
                  <button
                    mat-menu-item
                    (click)="openChangePasswordDialog(item)"
                  >
                    <mat-icon svgIcon="password"></mat-icon>
                    <span>Cambiar contraseña</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <div class="w-100 text-center pt-3 text-muted" *matNoDataRow>
          Sin resultados para mostrar
        </div>
      </mat-table>
    </div>
  </div>
  <mat-paginator
    card-drawer-paginator
    [length]="(dataSource.total$ | async) ?? 0"
    [pageSize]="dataSource.PAGE_SIZE"
    [pageSizeOptions]="dataSource.PAGE_SIZE_OPTIONS"
    #paginator
  >
  </mat-paginator>

  <t-llevo-driver-detail-tab card-drawer></t-llevo-driver-detail-tab>
</ui-card-table>
